import './App.css';
import { useState, useEffect } from 'react';
import {Route} from "react-router-dom";
import Homepage from "./Pages/Homepage";
import ChatPage from "./Pages/ChatPage";
import Toast from "./utils/Toast/Toast";
import {ChatState} from "./Context/ChatProvider";
import axios from "axios";
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import InfoModal from './components/Modals/InfoModal';
import ReactGA from "react-ga4";
axios.defaults.withCredentials = true;

function App() {
    const authUser = true;
    const [loading, setLoading] = useState(false);
    const {list, updateUser, isOffline, setIsOffline, infoIsOpen, user, setUser }  = ChatState();
    const history = useHistory();

useEffect(() => {
        const storedData = localStorage.getItem("userInfo");
        const currentPath = window.location.pathname;

        if (currentPath === "/chats" && storedData) {
            if (!user) {
                updateUser(JSON.parse(storedData));
            }
            return; 
        }
        if (!storedData && currentPath === "/") {
            setLoading(false);
            return; 
        }

        const goOnline = () => setIsOffline(false);
        const goOffline = () => setIsOffline(true);
    
        window.addEventListener('online', goOnline);
        window.addEventListener('offline', goOffline);
        const checkAuth = async () => {
        try {
          setLoading(true);
          const response = await axios.get( `${process.env.REACT_APP_API_URL}/api/user/me`);
          if (response.data.success) {
            localStorage.setItem("userInfo", JSON.stringify(response.data));
            updateUser(response.data );
            if (window.location.pathname !== "/chats") {
              history.push("/chats");
            }
          }
        } catch (err) {
          console.warn("❌ API Error:", err.response?.status || err.message);
          if (!err.response) {
              console.log("No internet connection.");
              return;
          }
          if (err.response.status === 401 || err.response.status === 403 ) {
              setUser(null);
              localStorage.removeItem("userInfo");
              history.push("/");
          } else if (err.response.status >= 500) {
            console.error("Wait for Internet.");
          }
        } finally {
          setLoading(false);
        } 
      };
      checkAuth();
      return () => {
          window.removeEventListener('online', goOnline);
          window.removeEventListener('offline', goOffline);
      };
}, []);

  //Google-analythics
  const MEASUREMENT_ID = "G-W0TFNZ2JQ8"; 
  ReactGA.initialize(MEASUREMENT_ID);
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });

  return (
    <div className="App">
        {isOffline && <div className='offline '> Offline mode. Check the connection. </div>}
        {infoIsOpen && <div className='info'> <InfoModal /> </div>}
        <Route path="/" component={Homepage} exact />
        <Route path="/chats" component={ChatPage} />
        <Toast  toastList={list} position="top-right"  autoDelete = {true} autoDeleteTime={5530} />
    </div>
  );
}

export default App;
